import { z } from "zod";

const UpdateInventorySchema = z.object({
    category_id: z.string().uuid("Invalid category ID"),
    item_name: z.string().min(1, "Item name is required"),
    price: z.number().min(0, "Price must be 0 or greater"),
});

export { UpdateInventorySchema };
export type UpdateInventoryFormData = z.infer<typeof UpdateInventorySchema>;
